import {
  BarChart3Icon,
  BoxIcon,
  BrainIcon,
  CalculatorIcon,
  ClipboardCheckIcon,
  EyeIcon,
  LayersIcon,
  LibraryIcon,
  PuzzleIcon,
  RulerIcon,
  SigmaIcon,
  ZapIcon,
} from 'lucide-react'

export const PRODUCT_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/wkQsRZFejZf9fQPfxFrnm7/455b4ddd-4865-4002-b0e8-ccf46c604756_(1).webp'

export const PRODUCT_MOCKUP_ALT =
  'MATHE BEREIT™ Komplettpaket: 6 Bände mit Zahlen & Rechnen, Geometrie, Messen, Algebra, Statistik und Problemlösen sowie 5 exklusive Bonus-Pakete.'

export const PRICE = '17,99 €'
export const PRICE_VALUE = 17.99
export const TOTAL_VALUE = '59,97 €'
export const SAVINGS = '41,98 €'
export const DISCOUNT = '70 %'
export const BONUS_TOTAL = '35 €'

export const heroGuarantees = ['Sofort-Download', 'Sichere Bezahlung', '30 Tage Geld-zurück-Garantie']

export const offerGuarantees = ['Einmalige Zahlung', 'Sofort-Download', 'Sichere Bezahlung']

export const stats = [
  { value: '6', label: 'Komplette Bände' },
  { value: 'Alle', label: 'wichtigen Mathematikbereiche' },
  { value: '100%', label: 'druckbar & digital' },
]

export const differenceStats = [
  { value: '6', label: 'Bände', sub: '' },
  { value: 'Alle', label: 'wichtigen Themen', sub: 'in einem System' },
  { value: '100%', label: 'druckbar & digital', sub: '' },
]

export const beforeItems = [
  'Sonntagabends auf der Suche nach passenden Aufgaben für Montag.',
  'Material aus verschiedenen Quellen zusammengesucht.',
  'Arbeitsblätter selbst angepasst und neu erstellt.',
  'Unsicher, wie du unterschiedliche Lernstände gleichzeitig fördern sollst.',
  'Kein roter Faden zwischen den verschiedenen Mathematikthemen.',
]

export const afterItems = [
  'Fertige Unterrichtsmaterialien, sofort einsetzbar.',
  'Alle wichtigen Mathematikbereiche in einem System.',
  'Visuelle Erklärungen und Übungen bereits vorbereitet.',
  'Differenzierungen für unterschiedliche Lernstände inklusive.',
  'Lernstandschecks, Lösungen und Referenzkarten direkt dabei.',
  'Ein strukturiertes Mathematik-System statt einzelner Arbeitsblätter.',
]

export const recognizeItems = [
  'Du suchst sonntagabends noch nach passenden Aufgaben für die Mathestunde am Montag.',
  'Du kombinierst Arbeitsblätter aus verschiedenen Quellen und versuchst daraus eine sinnvolle Stunde zu bauen.',
  'Du hast Schüler mit unterschiedlichen Lernständen und musst ständig Aufgaben anpassen.',
  'Du möchtest Mathematik verständlich und visuell erklären, aber dir fehlt die Zeit, alles selbst vorzubereiten.',
]

export const packFeatures = [
  {
    icon: LibraryIcon,
    title: '6 komplette Bände',
    text: 'Ein vollständiges System für die wichtigsten Mathematikbereiche.',
  },
  {
    icon: EyeIcon,
    title: 'Visuelle Schritt-für-Schritt-Erklärungen',
    text: 'Mathematische Inhalte werden nicht nur beschrieben, sondern sichtbar und verständlich erklärt.',
  },
  {
    icon: ZapIcon,
    title: 'Sofort einsetzbare Übungen & Aktivitäten',
    text: 'Öffnen, auswählen und direkt im Unterricht verwenden.',
  },
  {
    icon: LayersIcon,
    title: 'Differenzierungen & Level Up',
    text: 'Aufgaben für unterschiedliche Lernstände einfach anpassen.',
  },
  {
    icon: ClipboardCheckIcon,
    title: 'Lernstandschecks & Lösungen',
    text: 'Schnell erkennen, was verstanden wurde und wo noch Unterstützung nötig ist.',
  },
  {
    icon: PuzzleIcon,
    title: 'Praxisnahes Problemlösen',
    text: 'Sachaufgaben, Strategien, Logik und mathematisches Denken.',
  },
]

export const instantItems = [
  'Alle 6 kompletten Bände.',
  'Visuelle Erklärungen zu den wichtigsten Mathematikthemen.',
  'Übungen, Aktivitäten und Unterrichtskarten.',
  'Differenzierte Aufgaben für verschiedene Lernstände.',
  'Lernstandschecks und Lösungen.',
  'Quick-Reference-Seiten für den Unterricht.',
  'Sofort einsetzbar — zum Ausdrucken oder digital am Bildschirm.',
  'Druck so oft du willst — nie wieder ständig neue Materialien suchen.',
]

export const volumes = [
  { number: '01', title: 'Zahlen & Rechnen', icon: CalculatorIcon },
  { number: '02', title: 'Geometrie & Raum', icon: BoxIcon },
  { number: '03', title: 'Größen, Messen & Einheiten', icon: RulerIcon },
  { number: '04', title: 'Algebra & Gleichungen', icon: SigmaIcon },
  { number: '05', title: 'Daten, Statistik & Wahrscheinlichkeit', icon: BarChart3Icon },
  { number: '06', title: 'Sachaufgaben, Logik & Problemlösen', icon: BrainIcon },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/cbtXccHnZamYZVarZjpfQi/Captura-de-pantalla-2026-09-26-a-la_s_-3.57.09_p._m..webp',
    level: 'Klasse 1–2 · Zahlen',
    title: '100er-Detektive',
    caption:
      'Die Hundertertafel mit Spalten- und Zeilenhilfen (+1, −1, +10, −10), dazu „Welche Zahl fehlt?“-Rätsel und eine Level-Up-Aufgabe zu den Vielfachen von 3.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nfzJWG19gXtiUPnonEMJ93/Captura-de-pantalla-2026-09-26-a-la_s_-3.58.00_p._m..webp',
    level: 'Klasse 1–2 · Addition',
    title: 'Verdoppel-dich!',
    caption:
      'Verdoppeln und Fast-Verdoppeln mit Punktebildern: Die Schüler sehen, warum 6 + 7 dasselbe ist wie 6 + 6 + 1. Mit Mission gegen die Zeit.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/j1yQ5rFr1YDhT5PFi2Ru59/Captura-de-pantalla-2026-09-26-a-la_s_-3.59.21_p._m..webp',
    level: 'Klasse 2–3 · Fehleranalyse',
    title: 'Finde den Fehler',
    caption:
      'Drei typische Rechenfehler zum Aufdecken, Korrigieren und Erklären – mit Lehrerhinweis zum häufigsten Fehler.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9TDRg9Ysa6ebXQBDPz7MpX/Captura-de-pantalla-2026-09-26-a-la_s_-4.00.00_p._m..webp',
    level: 'Klasse 2–4 · Subtraktion',
    title: 'Schrittweise zurück',
    caption:
      'Erst die Zehner, dann die Einer: Subtraktion in zwei Schritten mit Zehnerstäben und Zahlenstrahl, Übungen und Differenzierung in drei Niveaus.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aRpnW95zPphJTbk1iXrjAk/Captura_de_pantalla_2026-09-26_a_la(s)_4.01.13_p.webp',
    level: 'Klasse 3 · Multiplikation',
    title: 'Doppeln hilft',
    caption:
      'Die Verdopplungsstrategie mit Punktfeldern: Aus 4 × 6 wird 8 × 6. Mit Übungspaaren, Merksatz und Challenge.',
  },
]

export type Bonus = {
  title: string
  was: string
  text: string
  image: string
  imageAlt: string
}

export const bonuses: Bonus[] = [
  {
    title: 'MATHE BEREIT™ Jahresplaner',
    was: '9 €',
    text: 'Das komplette Planungssystem für deinen Mathematikunterricht — mit Jahres-, Monats- und Wochenplanung.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a2d1c81d-3be1-444b-be08-8e5dbaff6927.jpg',
    imageAlt: 'Cover Bonus MATHE BEREIT™ Jahresplaner',
  },
  {
    title: '3 Level Differenzierungs-Masterkit',
    was: '8 €',
    text: 'Eine Aufgabe. Drei Niveaus. Passe Materialien innerhalb weniger Sekunden an unterschiedliche Lernstände an.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7143b295-c39b-4f48-be97-cf39a3ccdedd.jpg',
    imageAlt: 'Cover Bonus Differenzierungs-Masterkit',
  },
  {
    title: 'Mathe Starter & Spiele Vault',
    was: '6 €',
    text: '50 schnelle Warm-ups, Spiele, Challenges und Aktivitäten für deinen Unterricht.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/010baf39-f925-49e8-a58e-e120332e4f08.jpg',
    imageAlt: 'Cover Bonus Mathe Starter & Spiele',
  },
  {
    title: 'Diagnostik & Lernstand Masterkit',
    was: '6 €',
    text: '5-Minuten-Checks, Exit Tickets, Beobachtungsbögen und Diagnosekarten.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/0eba3555-e2b0-4d21-b7b9-e5d745c71220.jpg',
    imageAlt: 'Cover Bonus Diagnostik',
  },
  {
    title: 'Mathe Notfallstunden – Open & Teach',
    was: '6 €',
    text: '30 vorbereitete Mathematikstunden für Tage, an denen keine Vorbereitungszeit bleibt.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/1ad31710-ea3e-4236-bef1-1b89fd926c66.jpg',
    imageAlt: 'Cover Bonus Notfallstunden',
  },
]

export const offerRows = [
  { label: '6 komplette Bände', value: '24,97 €' },
  { label: '5 exklusive Boni', value: '35 €' },
]

export const testimonials = [
  {
    quote:
      'Ich habe früher jeden Sonntag drei, vier Stunden für die Mathe-Vorbereitung gebraucht. Jetzt öffne ich den passenden Band, wähle die Einheit aus und bin in zehn Minuten fertig. Die visuellen Erklärungen verstehen sogar meine schwächsten Schüler.',
    name: 'Katrin S.',
    role: 'Grundschullehrerin, Klasse 3',
    location: 'Nürnberg',
    featured: true,
  },
  {
    quote:
      'Die Differenzierung in drei Niveaus spart mir unglaublich viel Zeit. Endlich muss ich nicht mehr jedes Arbeitsblatt selbst umbauen.',
    name: 'Markus W.',
    role: 'Mathelehrer, Klasse 6',
    location: 'Hannover',
    featured: false,
  },
  {
    quote:
      'Die Notfallstunden haben mich schon mehrfach gerettet, wenn ich kurzfristig vertreten musste. Öffnen, erklären, fertig.',
    name: 'Anna L.',
    role: 'Lehrerin, Sekundarstufe I',
    location: 'Leipzig',
    featured: false,
  },
  {
    quote:
      'Endlich ein roter Faden durch alle Themen. Meine Kinder freuen sich richtig auf die Warm-ups aus dem Spiele-Vault.',
    name: 'Julia M.',
    role: 'Grundschullehrerin, Klasse 2',
    location: 'München',
    featured: false,
  },
  {
    quote:
      'Die Lernstandschecks zeigen mir in fünf Minuten, wer noch Hilfe braucht. Das hat meine Planung komplett verändert.',
    name: 'Thomas K.',
    role: 'Mathelehrer, Klasse 8',
    location: 'Hamburg',
    featured: false,
  },
]

export const guaranteeSteps = [
  { title: 'Kaufen & testen', text: 'Nutze alle 6 Bände und die 5 Boni 30 Tage lang in deinem Unterricht.' },
  { title: 'Nicht überzeugt?', text: 'Schreib uns einfach eine kurze E-Mail – ohne Begründung.' },
  { title: 'Geld zurück', text: 'Du bekommst den vollen Betrag erstattet. Ohne Fragen.' },
]

export const faqs = [
  {
    q: 'Für welche Klassenstufen ist MATHE BEREIT™ geeignet?',
    a: 'MATHE BEREIT™ deckt Mathematik von Klasse 1 bis Klasse 10 ab – von der Grundschule bis zur Sekundarstufe I.',
  },
  {
    q: 'Ist es für mein Bundesland geeignet?',
    a: 'Ja. Die Inhalte orientieren sich an den bundesweiten Bildungsstandards im Fach Mathematik und lassen sich in allen Bundesländern einsetzen.',
  },
  {
    q: 'Brauche ich besondere Materialien?',
    a: 'Nein. Du brauchst nur einen Drucker oder einen Bildschirm – alle Aktivitäten funktionieren mit einfachen Materialien aus dem Klassenzimmer.',
  },
  {
    q: 'Welches Format bekomme ich?',
    a: 'Du erhältst alle Bände und Boni als PDF – zum Ausdrucken oder digital am Bildschirm, Tablet oder Whiteboard.',
  },
  {
    q: 'Wie erhalte ich das Paket?',
    a: 'Direkt nach dem Kauf bekommst du per E-Mail deinen Zugang zum sofortigen Download.',
  },
  {
    q: 'Kann ich es für mehrere Klassen nutzen?',
    a: 'Ja. Du kannst die Materialien für alle deine Klassen verwenden und so oft ausdrucken, wie du möchtest.',
  },
  {
    q: 'Brauche ich besondere Mathematik-Vorkenntnisse, um es einzusetzen?',
    a: 'Nein. Jede Einheit enthält visuelle Schritt-für-Schritt-Erklärungen und Lösungen, sodass du direkt loslegen kannst.',
  },
  {
    q: 'Ist es einmalig zu bezahlen?',
    a: 'Ja. Du zahlst einmalig 17,99 € – kein Abonnement, keine versteckten Kosten.',
  },
]

export const footerLinks = ['AGB', 'Datenschutz', 'Kontakt', 'Impressum']
